/** @jsxImportSource @emotion/react */

import { Box, Alert as MuiAlert, Slide, Typography, useTheme } from '@mui/material'
import { alertContainer, badgeContainer } from './Alert.styles'

interface AlertProps {
  message: string
  open?: boolean
  children?: React.ReactNode
}

export const Alert = ({ message, open = true, children }: AlertProps) => {
  const theme = useTheme()

  if (!open) return null

  return (
    <Slide direction="down" in={open}>
      <MuiAlert severity="info" icon={false} css={alertContainer({ theme })}>
        <Box css={badgeContainer({ theme })}>
          {children}
          <Typography variant="body1" color="primary">
            {message}
          </Typography>
        </Box>
      </MuiAlert>
    </Slide>
  )
}
